import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {RELEVANT_PROCESS_FRAGMENT} from 'relevant-items/RelevantItemsSection';

export const STORABLE_RELEVANT_ITEMS_FRAGMENT = gql`
  fragment StorableRelevantItemsGraphQL on RelevantItemsNode {
    tagged {
      ... on FolderItemInterface {
        id
        name
        folder {
          id
          source {
            name
          }
        }
        modifiedAt
      }
      ... on StageEntryNode {
        id
        name
        modifiedAt
      }
      ... on EntryLikeDocumentNode {
        id
        name
        modifiedAt
        parent {
          ... on WorksheetNode {
            id
            folder {
              id
              source {
                name
              }
            }
          }
        }
        parentId
      }
    }
    taggedStorables {
      id
      name
      modifiedAt
      source {
        name
      }
    }
    filesMentioning {
      ... on FolderItemInterface {
        id
        name
        modifiedAt
        folder {
          id
          source {
            name
          }
        }
      }
      ... on StageEntryNode {
        id
        name
        modifiedAt
      }
      ... on EntryLikeDocumentNode {
        id
        name
        modifiedAt
        parent {
          ... on WorksheetNode {
            id
            folder {
              id
              source {
                name
              }
            }
          }
        }
        parentId
      }
    }
    processTasks {
      id
      name
      process {
        ...RelevantProcessGraphQL
      }
    }
    processOutputs {
      id
      name
      process {
        ...RelevantProcessGraphQL
      }
    }
  }
  ${RELEVANT_PROCESS_FRAGMENT}
`;

export const STORABLE_RELEVANT_ITEMS_QUERY = gql`
  query StorableRelevantItemsQuery($storableId: StrictString!) @skipAudit @engComponent(name: INVENTORY) {
    storable(id: $storableId) {
      ... on StorableInterface {
        id
        relevantItems {
          ...StorableRelevantItemsGraphQL
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
  ${STORABLE_RELEVANT_ITEMS_FRAGMENT}
`;
